import React from "react";
var __jsx = React.createElement;
import { t } from "i18next";
export var Labs = function Labs(_ref) {
  var labs = _ref.labs;
  return /*#__PURE__*/React.createElement("div", {
    className: "mb-3"
  }, /*#__PURE__*/React.createElement("div", {
    className: "text-[12px] text-left text-gray-500 dark:text-gray-500 mb-1"
  }, t("label.labs")), /*#__PURE__*/React.createElement("div", {
    className: "text-[16px] text-left text-gray-700 dark:text-gray-300"
  }, labs));
};